import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { IKeyData } from "infrastructure";
import { INotification } from "infrastructure/notification";
import { actionProcessing } from "infrastructure/store";

import { ITenant, getInitialTenantsState, ITenantsState } from "./Tenant.state";

const initialState = getInitialTenantsState();

export const tenants = createSlice({
  name: "tenants",
  initialState: initialState,
  reducers: {
    loadTenants: (state, action: PayloadAction<IKeyData>) => {
      return {
        ...state,
        [action.payload.id]: { ...state[action.payload.id], isLoading: true, notification: undefined }
      };
    },
    loadTenantsCompleted: (state, action: PayloadAction<IKeyData<ITenant[]>>) => {
      return {
        ...state,
        [action.payload.id]: { ...state[action.payload.id], isLoading: false, items: action.payload.data, initialized: true }
      };
    },
    loadTenantsFailed: (state, action: PayloadAction<IKeyData<INotification>>) => {
      return {
        ...state,
        [action.payload.id]: { ...state[action.payload.id], isLoading: false, notification: action.payload.data }
      };
    },
    reset: actionProcessing.createWithClearNotification((state: ITenantsState, action: PayloadAction<IKeyData>) => {
      const { [action.payload.id]: _, ...rest } = state;

      return {
        ...rest
      };
    }),
    clearTenants: (state, action: PayloadAction<IKeyData>) => {
      return {
        ...state,
        [action.payload.id]: { ...state[action.payload.id], isLoading: false, items: [] }
      };
    }
  }
});
